import { useAddReleaseToFolder, useFolders } from '../../hooks/useFolders'
import { Release } from '../../types/release'
import { Modal } from '../common'
import { useToast } from '../../context/ToastContext'
import styles from './AddReleaseToFolderModal.module.css'

interface AddReleaseToFolderModalProps {
  release: Release | null
  onClose: () => void
}

export function AddReleaseToFolderModal({ release, onClose }: AddReleaseToFolderModalProps) {
  const { data, isLoading } = useFolders()
  const addToFolder = useAddReleaseToFolder()
  const { showToast } = useToast()
  const folders = data?.folders ?? []

  const handleAdd = async (folderId: number, folderName: string) => {
    if (!release) return
    try {
      await addToFolder.mutateAsync({ folderId, releaseId: release.id })
      showToast(`Added "${release.title}" to ${folderName}`, 'success')
      onClose()
    } catch (error: any) {
      showToast(error?.response?.data?.error || 'Failed to add release to folder', 'error')
    }
  }

  return (
    <Modal open={!!release} onClose={onClose} title="Add to folder" size="sm">
      {isLoading ? (
        <div className={styles.empty}>Loading folders...</div>
      ) : folders.length === 0 ? (
        <div className={styles.empty}>Create a folder from the menu first.</div>
      ) : (
        <div className={styles.folderList}>
          {folders.map(folder => (
            <button
              key={folder.id}
              className={styles.folderButton}
              onClick={() => handleAdd(folder.id, folder.name)}
              disabled={addToFolder.isPending}
            >
              <i className="bi bi-folder" style={{ color: folder.color }} aria-hidden="true"></i>
              <span>{folder.name}</span>
              {folder.release_count !== undefined && (
                <span className={styles.folderCount}>{folder.release_count}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </Modal>
  )
}
